import React from "react";
import cs from "classnames";

import { useAnchorRedirectWarning } from "@js/hooks/anchor-redirect-warning";

import type { prepareDOMInputFun, SanitizeConfig } from "../../services";
import { prepareDOMInput } from "../../services";

import styles from "./style.module.scss";

type SanitizeProps = {
  className?: string;
  keepOriginalStyles?: boolean;
  unescape?: boolean;
  markdown?: boolean;
  prepareInput?: prepareDOMInputFun;
  input: string | null | undefined;
  config?: SanitizeConfig;
  style?: React.CSSProperties;
  whiteSpacePreLine?: boolean;
  postSanitizeContent?: (sanitizedText: string) => string;
};

export const Sanitize = ({
  className = "",
  keepOriginalStyles = false,
  unescape = false,
  markdown = true,
  prepareInput = prepareDOMInput,
  whiteSpacePreLine = false,
  input,
  config,
  postSanitizeContent = (sanitizedText) => sanitizedText,
  ...props
}: SanitizeProps) => {
  const { anchorWrapperRef } = useAnchorRedirectWarning<HTMLDivElement>();
  if (!input) {
    return null;
  }

  return (
    <div
      data-testid="sanitized"
      className={cs(styles.sanitizedContent, className, {
        [styles.noPMargin]: !keepOriginalStyles,
        "text-content": !className,
        [styles.whiteSpacePreLine]: whiteSpacePreLine,
        [styles.whiteSpaceNormal]: !whiteSpacePreLine,
      })}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: postSanitizeContent(
          prepareInput(input || "", {
            markdown,
            unescape,
            sanitize: config,
          }),
        ),
      }}
      ref={anchorWrapperRef}
      {...props}
    />
  );
};
